angular.module('jericho')

.directive('kdGateOr', function ($log, kdGate)
{
    return {
        restrict: 'A',
        link: function ($scope, element, attrs) {
            function gateElement(ability)
            {
                if (!ability) {
                    $log.error('kdGate ability cannot be empty', ability);
                    return;
                }

                let abilities  = ability.split('|');

                let allowed = abilities.reduce((result, value) => {
                    return result || kdGate.allows(value);
                }, false);

                if (allowed) {
                    element.removeClass('ng-hide');
                } else {
                    element.addClass('ng-hide');
                }
            }

            gateElement(attrs.kdGateOr);

            $scope.$on('kdAuth:userChanged', function () {
                gateElement(attrs.kdGateOr);
            });
        }
    };
});
